// @ts-check
import React, { Component } from 'react';
import _ from 'lodash';
import { ReactSelectProps, OptionValues } from 'react-select'; // eslint-disable-line no-unused-vars
import SelectWithArrayOfSimpleValues from './SelectWithArrayOfSimpleValues';

/**
 * Update value to the first option if the current value doesn't match any options.
 *
 * @param {Object} props - The props of the AutoSelect component
 * @param {boolean} props.autoSelect - Whether we should or shouldn't automatically select the first option
 * @param {any} props.value - The "value" of the Select according to external state
 * @param {(any) => void} props.onChange - The handler for a change of the select's value
 * @param {any[]} props.options - The options for the select
 * @param {string} props.valueKey - The property for the "value" of an option
 */
function doAutoSelect(props) {
  const { autoSelect, value, onChange, options, valueKey } = props;

  if (autoSelect && onChange) {
    const flattenedOptions = _.flatten((options || []).map(option => option.options || option));
    const selectedOption = flattenedOptions.find(option => option[valueKey] === value);
    if (!selectedOption && flattenedOptions.length) {
      onChange(flattenedOptions[0][valueKey]);
    }
  }
}

/** @typedef {{
  autoSelect?: boolean
} & ReactSelectProps<OptionValues>} AutoSelectPropsType */

/**
 * Auto select is a wrapper around react-select that automatically selects
 * the first option if no option is already selected. Specifically it calls
 * onChange with the first option in the options array.
 *
 * NB: I believe it assumes we're using simpleValue=true mode
 *
 * @augments { Component<AutoSelectPropsType, {}> }
 * */
class AutoSelect extends Component {
  componentDidMount() {
    doAutoSelect(this.props); // side effects
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.value !== this.props.value ||
      prevProps.valueKey !== this.props.valueKey ||
      !_.isEqual(prevProps.options, this.props.options)
    ) {
      doAutoSelect(this.props); // side effects
    }
  }

  render() {
    return <SelectWithArrayOfSimpleValues {...this.props} />;
  }
}

export default AutoSelect;
